'use client';
import { ReactNode } from 'react';
import cn from 'classnames';

import './RestrictSize.style.scss';

type RestrictSizeProps = {
  className?: string;
  children?: ReactNode;
};

function RestrictSize(props: RestrictSizeProps) {
  const { className = '', children } = props;

  return (
    <div className={cn('RestrictSize', 'shell-contained', className)}>
      {children}
    </div>
  );
}

export default RestrictSize;
